export default __webpack_public_path__ + "static/media/send.f82d4ccb.svg";